<ciao-user-group-table
  #viewAll
  [allowFocusChange]="true"
></ciao-user-group-table>
